/**
 * @file StepsWrapper.tsx
 *
 * @fileoverview Renders the steps wrapper component.
 * It sets the size of the main component based on the number of steps.
 */

import { ReactNode } from 'react';
import { Main } from '~/vcl/atoms/06-layout/09-main';

interface WizardStepsWrapperProps {
  /**
   * The total number of steps.
   */
  totalSteps: number;
  /**
   * The children.
   */
  children: ReactNode;
}

export default function WizardStepsWrapper({
  totalSteps,
  children,
}: WizardStepsWrapperProps) {
  return <Main size={totalSteps > 2 ? 'large' : 'small'}>{children}</Main>;
}
